export enum OperationTypes {
	'Entre' = 1,
	'Igual a' = 2,
	'Menor que' = 3,
	'Maior que' = 4,
	'Igual ou menor que' = 5,
	'Igual ou maior que' = 6,
}

export enum OperationTypesTranslation {
	'between' = 1,
	'equal_to' = 2,
	'less_than' = 3,
	'greater_than' = 4,
	'equal_or_less_than' = 5,
	'equal_or_greater_than' = 6,
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/enum/operation-types.ts